var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "102.000000pt",
    height: "36.000000pt",
    viewBox: "0 0 102.000000 36.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,36.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65 333 c-16 -16 -16 -38 0 -91 6 -19 3 -25 -24 -35 -35 -13 -44 -47 -12 -47 32 0 41 -21 28 -69 -11 -40 -10 -44 12 -62 32 -26 71 -25 71 1 0 13 -7 20 -19 20 -24 0 -33 23 -21 56 16 41 12 54 -22 69 -26 11 -28 14 -12 15 36 0 49 25 36 68 -10 31 -9 39 5 49 9 7 20 10 24 7 5 -3 9 4 9 15 0 17 -6 21 -29 21 -16 0 -37 -7 -46 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870 336 c0 -8 12 -17 26 -20 24 -6 25 -9 19 -61 -7 -53 -7 -54 20 -61 l28 -7 -27 -14 c-24 -13 -26 -18 -24 -66 3 -47 1 -52 -19 -55 -15 -2 -23 -10 -23 -23 0 -14 7 -19 30 -19 42 0 74 34 64 68 -16 57 -11 77 19 80 37 5 36 34 -3 49 -32 12 -36 26 -20 69 16 40 -10 74 -55 74 -23 0 -35 -5 -35 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261 307 c-45 -23 -66 -63 -65 -125 1 -68 14 -96 55 -117 41 -22 123 -17 127 7 3 15 -4 18 -47 18 -42 0 -53 4 -70 26 -60 77 9 197 89 154 13 -7 21 -6 29 4 9 11 7 18 -11 30 -27 19 -74 20 -107 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430 300 c0 -16 7 -20 30 -20 l30 0 0 -95 0 -95 -30 0 c-23 0 -30 -4 -30 -20 0 -18 7 -20 80 -20 73 0 80 2 80 20 0 16 -7 20 -30 20 l-30 0 0 95 0 95 30 0 c23 0 30 4 30 20 0 18 -7 20 -80 20 -73 0 -80 -2 -80 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640 185 c0 -128 1 -135 20 -135 18 0 20 7 20 55 l0 55 45 0 45 0 0 -55 c0 -48 2 -55 20 -55 19 0 20 7 20 135 0 128 -1 135 -20 135 -18 0 -20 -7 -20 -60 l0 -60 -45 0 -45 0 0 60 c0 53 -2 60 -20 60 -19 0 -20 -7 -20 -135z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSvg);
export default __webpack_public_path__ + "static/media/logoSvg.fdfb7b37a9dd5e1ce48aa565d0e3c165.svg";
export { ForwardRef as ReactComponent };